<div id="selection-popup" class="justificada-popup warning-popup actuation">
    <h2 class="m-b-5" mat-dialog-title>Marcar asuencia justificada</h2>
    <div mat-dialog-content id="leave-popup-fields">
        <app-document-upload title="Documento" (fileChanges)="onDocumentChanges($event)">
        </app-document-upload>

        <mat-progress-bar class="m-t-15" mode="indeterminate" *ngIf="isSaving"></mat-progress-bar>

        <div class="text-a-r p-t-5">
            <button mat-raised-button color="accent" class="m-r-15" (click)="onAcceptButtonClick()">Guardar</button>
            <button mat-raised-button color="warn" (click)="closeDialog()">Cancelar</button>
        </div>
    </div>
</div>